<template>
  <nav
    ref="combatNavBar"
    class="navbar-expand-lg bb-navbar p-2 px-4"
    :class="{ orange: isNotCurrent }"
  >
    <!---------------->
    <!-- CONTAINER  -->
    <!---------------->
    <div class="d-flex align-items-center text-center bb-combat-navbar">
      <!---------------->
      <!--    LOGO    -->
      <!---------------->
      <div class="bb-combat-navbar-logo">
        <router-link
          class="navbar-brand px-3"
          :to="{ name: 'campaignsView' }"
        >
          <img src="/bbLogo64Blue.png" />
        </router-link>
      </div>
      <!---------------->
      <!-- SCOREBOARD -->
      <!---------------->
      <div
        class="bb-combat-navbar-scoreboard flex-grow-1"
        :class="{ 'bb-scoreboard-hidden': hideScoreboard }"
      >
        <score-board
          :view_round_value="view_round"
          :combat_round_value="arena_round"
          :currentActionCombatantsCount="current_action_assigned_combatants"
          :unusedActionCount="unused_action_count"
          :extraAttacksMode="is_extra_attacks_in_progress"
          :showCombatantCounts="!playerMode"
          :showLockStatus="!playerMode"
          :showUnusedActionCount="!playerMode"
          @unused-action-hover-start="handleUnusedActionHoverStart"
          @unused-action-hover-end="handleUnusedActionHoverEnd"
          @view-round-hover-start="handleViewRoundHoverStart"
          @view-round-hover-end="handleViewRoundHoverEnd"
        >
          <template v-slot:arena_status>
            {{ arena_status }}
          </template>
          <template v-slot:arena_sub_status>
            {{ arena_sub_status }}
          </template>
          <template v-slot:arena_locked>
            {{ arena_locked_label }}
          </template>
          <template v-slot:active_combatants>
            {{ arena_active_combatants }}
          </template>
          <template v-slot:inactive_combatants>
            {{ arena_inactive_combatants }}
          </template>
          <template v-slot:combat_round>
            {{ arena_round }}
          </template>
          <template v-slot:combat_action>
            {{ arena_action }}
          </template>
          <template v-slot:view_round>
            {{ view_round }}
          </template>
          <template v-slot:unused_action_count>
            {{ unused_action_count }}
          </template>
          <template v-slot:which_round>
            {{ which_round }}
          </template>
        </score-board>
      </div>
      <!------------------>
      <!-- MENU         -->
      <!------------------>
      <div class="bb-combat-navbar-menu ms-auto">
        <div
          class="collapse navbar-collapse justify-content-end"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav ms-auto mt-2 align-items-end">
            <!----------------------->
            <!-- DROPDOWN          -->
            <!----------------------->
            <li class="nav-item me-3">
              <a>
                <button
                  class="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavDarkDropdown"
                  aria-controls="#navbarNavDarkDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div
                  class="collapse navbar-collapse"
                  id="navbarNavDarkDropdown"
                >
                  <!------------------------->
                  <!-- BUTTON (USERNAME)   -->
                  <!------------------------->
                  <li class="nav-item dropdown">
                    <a>
                      <button
                        class="btn dropdown-toggle btn-dark"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {{ user_name }}
                      </button>
                      <!--------------------->
                      <!-- DROPDOWN ITEMS  -->
                      <!--------------------->
                      <ul class="dropdown-menu dropdown-menu-dark mt-0">
                        <li v-if="!playerMode">
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="combatCharactersTarget"
                            >
                              Characters
                            </router-link>
                          </a>
                        </li>
                        <li v-if="!playerMode">
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="combatRacesTarget"
                            >
                              Races
                            </router-link>
                          </a>
                        </li>
                        <li v-if="!playerMode">
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="combatSpellsTarget"
                            >
                              Spells
                            </router-link>
                          </a>
                        </li>
                        <li v-if="!playerMode">
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="combatArtefactsTarget"
                            >
                              Artefacts
                            </router-link>
                          </a>
                        </li>
                        <li class="submenu submenu-md dropend">
                          <a
                            class="dropdown-item dropdown-toggle"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onclick="event.stopPropagation();"
                          >
                            Party
                          </a>
                          <ul class="dropdown-menu dropdown-menu-dark">
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                              >
                                <router-link
                                  class="nav-link"
                                  :to="{
                                    name: combatRouteName,
                                    params: currentCampaignSlug
                                      ? { slug: currentCampaignSlug }
                                      : {},
                                    query: { popup: 'party-kills' },
                                  }"
                                >
                                  Kills
                                </router-link>
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                              >
                                <router-link
                                  class="nav-link"
                                  :to="{
                                    name: combatRouteName,
                                    params: currentCampaignSlug
                                      ? { slug: currentCampaignSlug }
                                      : {},
                                    query: { popup: 'party-rolls' },
                                  }"
                                >
                                  Rolls
                                </router-link>
                              </a>
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                              >
                                <router-link
                                  class="nav-link"
                                  :to="{
                                    name: combatRouteName,
                                    params: currentCampaignSlug
                                      ? { slug: currentCampaignSlug }
                                      : {},
                                    query: { popup: 'party-runes' },
                                  }"
                                >
                                  Runes
                                </router-link>
                              </a>
                            </li>
                            <li v-if="!playerMode">
                              <a
                                class="dropdown-item"
                                href="#"
                              >
                                <router-link
                                  class="nav-link"
                                  :to="{
                                    name: combatRouteName,
                                    params: currentCampaignSlug
                                      ? { slug: currentCampaignSlug }
                                      : {},
                                    query: { popup: 'party-skills' },
                                  }"
                                >
                                  Skills
                                </router-link>
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li v-if="!playerMode">
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{
                                name: combatRouteName,
                                params: currentCampaignSlug
                                  ? { slug: currentCampaignSlug }
                                  : {},
                                query: { popup: 'log' },
                              }"
                            >
                              Log
                            </router-link>
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{ name: 'campaignsView' }"
                            >
                              Exit Combat
                            </router-link>
                          </a>
                        </li>
                        <div class="dropdown-divider"></div>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="combatHouseRulesTarget"
                            >
                              House Rules
                            </router-link>
                          </a>
                        </li>
                        <li class="submenu submenu-md dropend">
                          <a
                            class="dropdown-item dropdown-toggle"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onclick="event.stopPropagation();"
                          >
                            About
                          </a>
                          <ul class="dropdown-menu dropdown-menu-dark">
                            <li>
                              <a class="dropdown-item">{{ getVersion }}</a>
                            </li>
                          </ul>
                        </li>
                        <div class="dropdown-divider"></div>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                          >
                            <router-link
                              class="nav-link"
                              :to="{ name: 'logoutView' }"
                            >
                              Logout
                            </router-link>
                          </a>
                        </li>
                      </ul>
                    </a>
                  </li>
                </div>
              </a>
            </li>
            <!--------------------->
            <!-- AVATAR          -->
            <!--------------------->
            <li class="nav-item me-2">
              <img
                v-bind:src="avatar_image"
                height="70"
                width="70"
                class="rounded-circle bb-img"
                alt="Avatar"
              />
            </li>
            <!-- end items -->
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
//========================================================
// scripts
//---------
import { mapGetters } from 'vuex'
import ScoreBoard from '@/components/ScoreBoard.vue'
import getUnusedHoverPopulation from '@/helpers/getUnusedHoverPopulation'

export default {
  name: 'CombatNavbarComponent',
  //========================================================
  // components
  //------------
  components: {
    'score-board': ScoreBoard,
  },
  props: {
    playerMode: {
      type: Boolean,
      default: false,
    },
    hideScoreboard: {
      type: Boolean,
      default: false,
    },
  },
  //========================================================
  // data
  //------
  data() {
    return {
      version: '',
    }
  },
  //========================================================
  // computed
  //----------
  computed: {
    ...mapGetters('auth', {
      getUserProfile: 'getUserProfile',
    }),
    ...mapGetters('combat', {
      getVersion: 'getVersion',
      getConfig: 'getConfig',
      getInactiveCombatantCount: 'getInactiveCombatantCount',
      getActiveCombatantCount: 'getActiveCombatantCount',
      getCombatants: 'getCombatants',
      getUnusedActionCount: 'getUnusedActionCount',
      getViewRound: 'getViewRound',
      getArenaSubStatus: 'getArenaSubStatus',
      getCampaign: 'getCampaign',
    }),
    campaign() {
      return this.getCampaign || null
    },
    arena_round() {
      return this.campaign?.round || 0
    },
    arena_action() {
      return this.campaign?.action || 0
    },
    view_round() {
      return this.getViewRound || 0
    },
    unused_action_count() {
      return this.getUnusedActionCount || 0
    },
    user_name() {
      return this.getUserProfile?.user_name || ''
    },
    arena_status() {
      return this.campaign?.status || ''
    },
    arena_locked() {
      return this.campaign?.locked || false
    },
    avatar_image() {
      return this.getUserProfile?.avatar_image || null
    },
    arena_locked_label() {
      if (this.arena_locked) {
        return 'Locked'
      } else {
        return 'Unlocked'
      }
    },
    arena_active_combatants() {
      return this.getActiveCombatantCount || 0
    },
    current_action_assigned_combatants() {
      return getUnusedHoverPopulation({
        combatants: this.getCombatants || [],
        currentAction: this.arena_action,
        maxCA: this.getConfig?.max_ca || 0,
        extraAttacksMode: this.is_extra_attacks_mode,
      })
    },
    arena_inactive_combatants() {
      return this.getInactiveCombatantCount || 0
    },
    arena_sub_status() {
      return this.getArenaSubStatus || ''
    },
    is_extra_attacks_mode() {
      return String(this.arena_sub_status || '')
        .toLowerCase()
        .includes('extra attacks')
    },
    is_extra_attacks_in_progress() {
      return this.arena_sub_status === 'Extra Attacks In Progress'
    },
    currentCampaignSlug() {
      return this.campaign?.slug || ''
    },
    combatRouteQuery() {
      return this.currentCampaignSlug ? { slug: this.currentCampaignSlug } : {}
    },
    combatCharactersTarget() {
      return {
        name: 'combatCharacters',
        query: this.combatRouteQuery,
      }
    },
    combatRacesTarget() {
      return {
        name: 'combatRaces',
        query: this.combatRouteQuery,
      }
    },
    combatSpellsTarget() {
      return {
        name: 'combatSpells',
        query: this.combatRouteQuery,
      }
    },
    combatArtefactsTarget() {
      return {
        name: 'combatArtefacts',
        query: this.combatRouteQuery,
      }
    },
    combatHouseRulesTarget() {
      return {
        name: 'combatHouseRules',
        query: this.combatRouteQuery,
      }
    },
    combatRouteName() {
      return this.playerMode ? 'playerCombat' : 'manageCombat'
    },
    which_round() {
      const round =
        this.view_round > this.arena_round
          ? 'Future Round'
          : this.view_round < this.arena_round && this.view_round !== 0
            ? 'Previous Round'
            : ''
      return round
    },
    isNotCurrent() {
      return this.view_round !== this.arena_round && this.view_round !== 0
    },
  },
  //========================================================
  // methods
  //---------
  methods: {
    handleUnusedActionHoverStart() {
      if (
        this.playerMode ||
        this.unused_action_count <= 0 ||
        this.view_round !== this.arena_round ||
        this.unused_action_count >= this.current_action_assigned_combatants
      ) {
        return
      }

      this.emitter.emit('hover-unused-action-count-start')
    },
    handleUnusedActionHoverEnd() {
      if (this.playerMode) {
        return
      }

      this.emitter.emit('hover-unused-action-count-end')
    },
    handleViewRoundHoverStart() {
      this.emitter.emit('hover-view-round-start')
    },
    handleViewRoundHoverEnd() {
      this.emitter.emit('hover-view-round-end')
    },
  },
  //========================================================
  // mounted
  //---------
  mounted() {},
}
</script>

<style scoped>
.bb-navbar {
  position: relative;
  z-index: 2600;
}

.bb-navbar .dropdown-menu {
  z-index: 2601;
}

.bb-combat-navbar-logo,
.bb-combat-navbar-menu {
  flex: 0 0 auto;
}

.bb-combat-navbar {
  display: flex;
  width: 100%;
  min-width: 0;
  gap: 0.75rem;
}

.bb-combat-navbar-scoreboard {
  min-width: 0;
}

.bb-combat-navbar-menu {
  display: flex;
  justify-content: flex-end;
  min-width: 0;
}

.bb-navbar.orange {
  background-color: rgba(204, 139, 18, 0.904);
}

.bb-scoreboard-hidden {
  visibility: hidden;
}

.bb-scoreboard-hidden :deep(*) {
  pointer-events: none;
}
</style>
